function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var eventReactionEntities = function eventReactionEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull: {},
    byEventIdAndAuthUserId: {},
    byEventIdAndUserId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull = _objectSpread({}, state.byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull);
      var byEventIdAndUserId = _objectSpread({}, state.byEventIdAndUserId);
      action.response.forEach(function (eventListItem) {
        merge(byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull, eventListItem.eventReactionsByEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull);
        merge(byEventIdAndUserId, eventListItem.eventReactionByEventIdAndUserId);
      });
      return merge({}, state, {
        byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull: byEventIdAndUserFolloweesUserIdAndUserFolloweesConfirmedAtNotNull,
        byEventIdAndUserId: byEventIdAndUserId
      });
    case ActionTypes.POST_EVENTREACTION_SUCCESS:
      var byEventIdAndAuthUserId = _objectSpread({}, state.byEventIdAndAuthUserId);
      var embedded = action.response._embedded;
      var key = [action.eventReaction.eventId, action.eventReaction.userId].join("-");
      if (!byEventIdAndAuthUserId[key]) byEventIdAndAuthUserId[key] = [];
      byEventIdAndAuthUserId[key].push(embedded);
      var byEventIdAndUserId = _objectSpread({}, state.byEventIdAndUserId);
      byEventIdAndUserId[key] = embedded;
      return Object.assign({}, state, {
        byEventIdAndAuthUserId: byEventIdAndAuthUserId,
        byEventIdAndUserId: byEventIdAndUserId
      });
    case ActionTypes.DELETE_EVENTREACTION_SUCCESS:
      var byEventIdAndAuthUserId = _objectSpread({}, state.byEventIdAndAuthUserId);
      var key = [action.eventReaction.event.id, action.eventReaction.userId].join("-");
      if (byEventIdAndAuthUserId[key]) byEventIdAndAuthUserId[key] = byEventIdAndAuthUserId[key].filter(function (eventReaction) {
        return eventReaction.id !== action.eventReaction.id;
      });
      var byEventIdAndUserId = _objectSpread({}, state.byEventIdAndUserId);
      delete byEventIdAndUserId[key];
      return Object.assign({}, state, {
        byEventIdAndAuthUserId: byEventIdAndAuthUserId,
        byEventIdAndUserId: byEventIdAndUserId
      });
    case ActionTypes.POST_USERFOLLOWER_SUCCESS:
      var embedded = action.response._embedded;
      var byEventIdAndAuthUserId = _objectSpread({}, state.byEventIdAndAuthUserId);
      Object.keys(byEventIdAndAuthUserId).forEach(function (k) {
        var byAuthUserId = k.split("-")[1];
        if (byAuthUserId !== action.userFollower.userId) return;
        byEventIdAndAuthUserId[k].forEach(function (elem) {
          if (elem.user.username === action.userFollower.followeeUsername) elem.forr = embedded;
        });
      });
      return Object.assign({}, state, {
        byEventIdAndAuthUserId: byEventIdAndAuthUserId
      });
    case ActionTypes.DELETE_USERFOLLOWER_SUCCESS:
      var byEventIdAndAuthUserId = _objectSpread({}, state.byEventIdAndAuthUserId);
      Object.keys(byEventIdAndAuthUserId).forEach(function (k) {
        var byAuthUserId = k.split("-")[1];
        if (byAuthUserId !== action.userFollower.user.email) return;
        byEventIdAndAuthUserId[k].forEach(function (elem) {
          if (elem.user.username === action.userFollower.followee.username) elem.forr = null;
        });
      });
      return Object.assign({}, state, {
        byEventIdAndAuthUserId: byEventIdAndAuthUserId
      });
    default:
      return state;
  }
};
export default eventReactionEntities;